<template>
  <div>
    <div class="row page-titles">
      <div class="col-md-5 align-self-center">
        <h4 class="text-themecolor">Create new ticket</h4>
      </div>
      <div class="col-md-7 align-self-center text-right">
        <div class="d-flex justify-content-end align-items-center">
          <breadcrumb :parentpage="parentPage" :page="currentPage"/>
        </div>
      </div>
    </div>
    <form @submit.prevent="() => {}">
      <div class="row">
        <div class="col-md-12">
          <div class="card">
            <div class="card-header">
              Ticket Information
            </div>
            <div class="card-body">
              <div class="row">
                <div class="col-md-12" v-if="currentRole !== 'seller'">
                  <input-text
                    type="text"
                    :value="form.userId"
                    name="userId"
                    label="userId"
                    :required="true"
                    :errors="error.userId"
                    @input="value => { setField({ key: 'userId', value }) }"
                  />
                </div>
                <div class="col-md-12">
                  <input-text
                    type="text"
                    :value="form.title"
                    name="title"
                    label="Title"
                    :required="true"
                    :errors="error.title"
                    @input="value => { setField({ key: 'title', value }) }"
                  />
                </div>
                <div class="col-md-6" v-if="form.displayOrderId">
                  <input-text
                    type="text"
                    :value="form.orderId"
                    :disabled="true"
                    name="orderId"
                    label="Order Id"
                    :required="false"
                  />
                </div>
                <div :class="{'col-md-6': form.displayOrderId, 'col-md-12': !form.displayOrderId}">
                  <input-select
                    :value="form.topic"
                    name="topic"
                    label="Topic"
                    placeholder="Select topic"
                    :required="true"
                    :errors="error.topic"
                    :options="topicOptions"
                    @input="value => { setField({ key: 'topic', value }) }"
                  />
                </div>
                <div class="col-md-12">
                  <text-area
                    :value="form.message"
                    name="message"
                    label="Message"
                    placeholder="Message"
                    :required="true"
                    :errors="error.message"
                    @input="value => setField({ key: 'message', value })"
                  />
                </div>
                <div class="col-md-12">
                  <input
                    multiple
                    type="file"
                    accept="image/*"
                    ref="fileInput"
                    @change="processFile($event)"
                    @click="$refs.fileInput.value = null"
                  />
                </div>
              </div>
              <form-button
                type="info"
                input-type="button"
                :click="() => createTicket(currentRole)"
                :disabled="loading"
                :loading="loading"
                class="w-100 mt-4"
                text="SUBMIT"
              />
            </div>
          </div>
        </div>
      </div>
    </form>
  </div>
</template>

<script>
  import { mapGetters, mapActions } from "vuex";

  import LoadingContainer from "@/components/Misc/LoadingContainer";
  import FormButton from "@/components/Form/FormButton";
  import AlertBox from "@/components/Misc/AlertBox";
  import Breadcrumb from "@/components/Common/Breadcrumb";
  import LinkButton from "@/components/Misc/LinkButton";
  import InputText from "@/components/Form/InputText";
  import InputSelect from "@/components/Form/InputSelect";
  import TextArea from "@/components/Form/TextArea";

  export default {
    name: "TicketForm",
    components: {
      LoadingContainer,
      FormButton,
      AlertBox,
      Breadcrumb,
      LinkButton,
      InputText,
      InputSelect,
      TextArea,
    },
    beforeMount() {
      const query = this.$route.query;
      const orderId = query.orderId;

      this.displayOrder(orderId);
    },
    computed: {
      ...mapGetters({
        user: "auth/user",
        loading: "ticket/loading",
        form: "ticket/form",
        error: "ticket/error",
        images: "ticket/images",
      }),
      topicOptions() {
        return [
          { value: "Cancel", text: "Cancel" },
          { value: "Pre-shipment", text: "Pre-shipment" },
          { value: "Refund", text: "Refund" },
          { value: "Replacement", text: "Replacement" },
          { value: "Deposit", text: "Deposit" },
          { value: "Verify Address", text: "Verify Address" },
          { value: "Other", text: "Other" }
        ];
      },
      routeName() {
        return this.$router.name;
      },
      currentPage() {
        return this.$store.state.route.meta.title;
      },
      currentUser() {
        return this.user || {};
      },
      currentRole() {
        return this.currentUser.role;
      },
      parentPage() {
        let page = {
          title: "Ticket",
          name: "ticketList",
        };

        return page;
      },
    },
    methods: {
      ...mapActions({
        setField: "ticket/setField",
        createTicket: "ticket/createTicket",
        addImages: "ticket/addImages",
      }),
      processFile(event) {
        const uploadFiles = event.target.files;
        this.addImages({ files: [...uploadFiles] });
      },
      displayOrder(orderId) {
        if (orderId) {
          this.setField({ key: 'displayOrderId', value: true });
          this.setField({ key: 'orderId', value: orderId });
        } else {
          this.setField({ key: 'displayOrderId', value: false });
        }
      }
    }
  };
</script>
<style>
@import "../../assets/libs/dropify/dist/css/dropify.css";
</style>
